import { useState, useMemo } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Avatar,
  Grid,
  Paper,
  FormControl,
  InputLabel,
  OutlinedInput,
  IconButton,
} from "@mui/material";

import "../../styles.css";
import ChatbotHeader from "../GeneralPreview/ChatbotHeader";

interface IProps {
  chatbotSettings: any;
  chatbotAppearance: any;
}

const FormPreview = ({ chatbotSettings, chatbotAppearance }: IProps) => {
  const [previewChatbot, setPreviewChatbot] = useState<boolean>(false);

  const handleTogglePreview = () => {
    setPreviewChatbot((prevState) => !prevState);
  };

  const primaryButtonSettings = {
    background: chatbotAppearance?.["cuvo-chatbot-primary-button-bg-color"],
    color: chatbotAppearance?.["cuvo-chatbot-primary-button-text-color"],
    fontFamily:
      chatbotAppearance?.["cuvo-chatbot-primary-button-text-font-family"],
    fontWeight:
      chatbotAppearance?.["cuvo-chatbot-primary-button-text-font-weight"],
    fontStyle:
      chatbotAppearance?.["cuvo-chatbot-primary-button-text-font-style"],
    fontSize: chatbotAppearance?.["cuvo-chatbot-primary-button-text-font-size"],
  };

  const secondaryButtonSettings = {
    background: chatbotAppearance?.["cuvo-chatbot-secondary-button-bg-color"],
    color: chatbotAppearance?.["cuvo-chatbot-secondary-button-text-color"],
    fontFamily:
      chatbotAppearance?.["cuvo-chatbot-secondary-button-text-font-family"],
    fontWeight:
      chatbotAppearance?.["cuvo-chatbot-secondary-button-text-font-weight"],
    fontStyle:
      chatbotAppearance?.["cuvo-chatbot-secondary-button-text-font-style"],
    fontSize:
      chatbotAppearance?.["cuvo-chatbot-secondary-button-text-font-size"],
  };

  return (
    <Box>
      <Typography className="prev-text-titile">
        Chatbot Preview: Ticket Form &nbsp;
      </Typography>
      <Typography
        className="zoomicons guideTourViewActualSize"
        sx={{
          color: "#0157FF",
          fontSize: 12,
          textAlign: "center",
          cursor: "pointer",
        }}
        onClick={handleTogglePreview}
      >
        Click to preview actual size
      </Typography>
      {previewChatbot && <Box className="settings-overlay" />}
      <Box
        className={`${previewChatbot ? "settings-preview-form" : ""}`}
        sx={{
          marginTop: "10px",
        }}
      >
        {previewChatbot && (
          <Typography className="for-preview-form-preview">
            For Preview{" "}
            <span onClick={handleTogglePreview} className="prevclose">
              {" "}
              &nbsp; x &nbsp;Close&nbsp;
            </span>
          </Typography>
        )}
        <Grid item xs={12}>
          <Box
            sx={{
              background: chatbotAppearance?.["cuvo-chatbot-header-bg-color"],
            }}
          >
            {/* <Box>
            <TopBar />
          </Box> */}
            <Box mt="24px" p="7px">
              <ChatbotHeader
                chatbotSettings={chatbotSettings}
                chatbotAppearance={chatbotAppearance}
              />
            </Box>
          </Box>
        </Grid>
        <Grid
          container
          rowGap={previewChatbot ? "15px" : "7px"}
          sx={{
            background: "#FFF",
            padding: previewChatbot ? "20px" : "10px",
          }}
        >
          <Grid item xs={12} mt={0}>
            <Typography
              sx={{
                fontSize: previewChatbot ? "14px" : "12px",
              }}
            >
              Sorry that we couldn’t resolve the issue. I can have our customer
              success manager help you. Please provide the following
              information:
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>
                  First name
                  <div style={{ display: "inline-block", color: "red" }}>*</div>
                </InputLabel>
                <OutlinedInput
                  type="text"
                  value=""
                  id="fname-input"
                  label="First Name"
                />
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>Last name</InputLabel>
                <OutlinedInput
                  type="text"
                  value=""
                  id="lname-input"
                  label="Last Name"
                />
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>Email address</InputLabel>
                <OutlinedInput
                  type="text"
                  value=""
                  id="email-input"
                  label="Email Address"
                />
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>Mobile Number</InputLabel>
                <OutlinedInput
                  type="text"
                  value=""
                  id="mobile-input"
                  label="Mobile No"
                />
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box>
              <FormControl className="custom-select custom-textarea" fullWidth>
                <InputLabel>Comments</InputLabel>
                <OutlinedInput
                  type="textarea"
                  value=""
                  id="comments-input"
                  label="Comments"
                  sx={{ height: "100px" }}
                />
              </FormControl>
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            justifyContent="center"
            className="footer-action-btn"
          >
            <Button
              variant="contained"
              sx={{
                ":hover": {
                  boxShadow: "none",
                  bgcolor:
                    chatbotAppearance &&
                    chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                },
                fontSize: previewChatbot ? "14px" : "12px",
                background:
                  chatbotAppearance &&
                  chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                color:
                  chatbotAppearance &&
                  chatbotAppearance["cuvo-chatbot-bot-action-text-color"],
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                ":hover": {
                  boxShadow: "none",
                  bgcolor:
                    chatbotAppearance &&
                    chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                },
                fontSize: previewChatbot ? "14px" : "12px",
                background:
                  chatbotAppearance &&
                  chatbotAppearance["cuvo-chatbot-bot-action-bg-color"],
                color:
                  chatbotAppearance &&
                  chatbotAppearance["cuvo-chatbot-bot-action-text-color"],
              }}
            >
              Send
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default FormPreview;
